import React from "react"
import PropTypes from "prop-types"

import styles from "./Button.module.css"

const buttonKinds = {
  icon: "icon",
  primary: "primary",
  secondary: "secondary",
  cell: "cell",
}

class Button extends React.Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    event.target.blur()

    this.props.onClick(event)
  }

  render() {
    let buttonClass

    switch (this.props.kind) {
      case buttonKinds.secondary:
        buttonClass = styles.buttonSecondary
        break
      case buttonKinds.icon:
        buttonClass = styles.buttonIconed
        break
      case buttonKinds.cell:
        buttonClass = styles.buttonCell
        break
      default:
        buttonClass = styles.button
        break
    }

    if (this.props.kind === buttonKinds.icon) {
      return (
        <button
          type={this.props.type}
          className={buttonClass}
          onClick={this.handleClick}
        >
          <span className={styles.icon}>{this.props.icon}</span>
        </button>
      )
    } else {
      return (
        <button
          type={this.props.type}
          className={buttonClass}
          onClick={this.handleClick}
        >
          {this.props.children}
        </button>
      )
    }
  }
}

Button.defaultProps = {
  kind: buttonKinds.primary,
  type: "button",
  onClick: () => {},
}

Button.propTypes = {
  kind: PropTypes.oneOf(Object.values(buttonKinds)),
  type: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.element,
}

export default Button
